import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { Link } from "react-router-dom";
import { Form } from "react-bootstrap";
import { required, dropdown } from "../../../../../utils/forms/validators";
import Button from "../../../../../components/common/button/Button";
import Select2 from "../../../../../components/common/select/Select2";
import Typeahead from "../../../../../components/common/typeahead/Typeahead";
import styles from "./AdminCreateProjects.scss";

import { ADMIN_CREATE_PROJECTS_FORM } from "../../../../../actions/admin.actions";

const manager = dropdown("Please select a hiring manager.");

class AdminCreateProjects extends Component {
  constructor(props) {
    super(props);

    this.state = {
      location: {
        pathname: "/company/project/create",
        state: null
      }
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.managers !== this.props.managers) {
      const managerOptions = this.props.managers;

      if (managerOptions && managerOptions.length === 1) {
        const id = _.get(_.first(managerOptions), "id");

        // Select dropdown option
        this.props.change("manager_id", id);

        // Trigger onChange event with manager id
        this.onChange(id);
      }
    }
  }

  onChange(value) {
    let location = {
      pathname: "/company/project/create",
      state: { manager: value }
    };

    this.setState({ location: location });
  }

  render() {
    const {
      invalid,
      submitting,
      pristine,
      companies,
      isLoadingCompany,
      managers
    } = this.props;

    return (
      <section className={styles.adminCreateProjects}>
        <div className={styles.content}>
          <h2 className={styles.title}>Create Project</h2>
          <Form>
            <div className={styles.form}>
              <Field
                name="company_id"
                type="text"
                placeholder="Company Name"
                component={Typeahead}
                isAsync={true}
                options={companies}
                isLoading={isLoadingCompany}
                minLength={3}
                allowNew={false}
                labelKey="name"
                valueKey="id"
                validate={required}
                onSearch={query => {
                  this.props.onSearchCompanies(query);
                }}
                onChange={selected => {
                  if (selected[0] && selected[0].id) {
                    this.props.getAdminCompanyById(selected[0].id, false);
                  }
                }}
              />

              <Field
                name="manager_id"
                type="select"
                placeholder="Hiring Manager..."
                component={Select2}
                options={managers}
                valueKey="id"
                labelKey="name"
                validate={[required, manager]}
                onSelectChange={this.onChange}
                disabled={!managers}
                isLoading={companies && !managers ? true : false}
              />

              <div className={styles.dividerDouble} />

              <Link to={this.state.location}>
                <Button
                  isDisabled={invalid || submitting || pristine}
                  isPrimary
                  size="large"
                  label="Create"
                />
              </Link>
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

export default (AdminCreateProjects = reduxForm({
  form: ADMIN_CREATE_PROJECTS_FORM
})(AdminCreateProjects));



// WEBPACK FOOTER //
// ./src/routes/admin/new/projects/components/AdminCreateProjects.js